import debounce from 'lodash/fp/debounce';
import { useEffect } from 'react';
export var useDebounceEvent = function useDebounceEvent(_ref) {
  var getTarget = _ref.getTarget,
      event = _ref.event,
      callback = _ref.callback;
  var debounceCallback = debounce(150)(callback);
  useEffect(function () {
    getTarget().addEventListener(event, debounceCallback);
    return function () {
      getTarget().removeEventListener(event, debounceCallback);
    };
  }, [callback]);
};
export var useViewportResize = function useViewportResize(callback) {
  useDebounceEvent({
    event: 'resize',
    getTarget: function getTarget() {
      return window.visualViewport || window;
    },
    callback: callback
  });
};

var useResize = function useResize(callback) {
  useDebounceEvent({
    event: 'resize',
    getTarget: function getTarget() {
      return window;
    },
    callback: callback
  });
  useDebounceEvent({
    event: 'orientationchange',
    getTarget: function getTarget() {
      return window;
    },
    callback: callback
  });
};

export default useResize;